/**
 * Converts a query string to a hash map of key value pairs
 * @param {string} query
 * @returns {object}
 */
export const convertQueryStringToObj = function(query) {
  if (query.startsWith('?')) query = query.slice(1)
  var parts = query.split('&').filter(s => s)
  var obj = {}
  for (var i in parts) {
    var [key, value] = parts[i].split('=')
    key = decodeURI(key)
    value = decodeURI(value)
    if (key in obj) {
      if (!(obj[key] instanceof Array)) obj[key] = [obj[key]]
      obj[key].push(value)
    } else {
      obj[key] = value
    }
  }
  return obj
}

/**
 * Converts a key/value object into a query string.
 * @param {object} obj
 * @returns {string}
 */
export const convertObjToQueryString = function(obj) {
  var query = ''
  for (var key in obj) {
    var value = obj[key]
    if (value instanceof Array)
      value.forEach(
        value => (query += '&' + key + '=' + encodeURIComponent(value)),
      )
    else query += '&' + key + '=' + encodeURIComponent(value)
  }
  if (query) query = '?' + query.slice(1)
  return query
}

/**
 * Add a key / value to a query string.
 * @param {string} query
 * @param {string} key
 * @param {string} value
 */
export const queryStringAdd = function(query, key, value) {
  var hash = convertQueryStringToObj(query)
  hash[key] = value
  return convertObjToQueryString(hash)
}

/**
 * Add a value to a existing query key.
 * @param {string} query
 * @param {string} key
 * @param {string} value
 */
export const queryStringAddExist = function(query, key, value) {
  var hash = convertQueryStringToObj(query)
  if (hash.hasOwnProperty(key)) {
    if (!(hash[key] instanceof Array)) hash[key] = [hash[key]]
    if (!hash[key].includes(decodeURI(encodeURIComponent(value))))
      hash[key].push(value)
  } else {
    hash[key] = value
  }
  return convertObjToQueryString(hash)
}

/**
 * Remove a key from a query string
 * @param {string} query
 * @param {string} key
 */
export const queryStringRemove = function(query, key) {
  var hash = convertQueryStringToObj(query)
  delete hash[key]
  return convertObjToQueryString(hash)
}

/**
 * Remove a value from a existing key
 * @param {string} query
 * @param {string} key
 */
export const queryStringRemoveExist = function(query, key, value) {
  var hash = convertQueryStringToObj(query)
  if (!(hash[key] instanceof Array)) hash[key] = [hash[key]]
  hash[key] = hash[key].filter(v => v != decodeURI(encodeURIComponent(value)))
  if (hash[key].length == 0) delete hash[key]
  return convertObjToQueryString(hash)
}

/**
 * Get the value for a key from the query
 * @param {string} query
 * @param {string} key
 */
export const queryStringGet = function(query, key) {
  var hash = convertQueryStringToObj(query)
  return key in hash ? hash[key] : null
}

/**
 * Add a key/value to the browser url.
 * @param {string} key
 * @param {string} value
 */
export const urlSet = function(key, value) {
  var { protocol, host, pathname, search } = window.location
  var url =
    protocol + '//' + host + pathname + queryStringAdd(search, key, value)
  window.history.pushState(
    {
      path: url,
    },
    '',
    url,
  )
}

export const urlAdd = urlSet

/**
 *  Add a value to a existing query key.
 * @param {string} key
 * @param {string} value
 */
export const urlAddExist = function(key, value) {
  const { protocol, host, pathname, search } = window.location
  const url = `${protocol}//${host}${pathname}${queryStringAddExist(
    search,
    key,
    value,
  )}`
  window.history.pushState(
    {
      path: url,
    },
    '',
    url,
  )
}

/**
 * Remove a key from the browser url.
 * @param {string} key
 * @param {string} value
 */
export const urlRemove = function(key) {
  var { protocol, host, pathname, search } = window.location
  var url = protocol + '//' + host + pathname + queryStringRemove(search, key)
  window.history.pushState(
    {
      path: url,
    },
    '',
    url,
  )
}

/**
 * Remove a value from the existing key.
 * @param {string} key
 * @param {string} value
 */
export const urlRemoveExist = function(key, value) {
  const { protocol, host, pathname, search } = window.location
  const url = `${protocol}//${host}${pathname}${queryStringRemoveExist(
    search,
    key,
    value,
  )}`
  window.history.pushState(
    {
      path: url,
    },
    '',
    url,
  )
}

/**
 * Get the url value from the query string.
 * @param {string} key
 * @returns {string|null}
 */
export const urlGet = function(key) {
  var val = queryStringGet(window.location.search, key)
  return typeof val === 'string'
    ? decodeURIComponent(encodeURIComponent(val))
    : Array.isArray(val)
    ? val.map(v => decodeURIComponent(encodeURIComponent(v)))
    : val
}
